import {createRouter, createWebHashHistory} from 'vue-router';
import HomeView from '../views/HomeView.vue';
import LoginView from '@/views/LoginView';
import ResetPasswordView from '@/views/ResetPasswordView';
import ChangePasswordView from '@/views/ChangePasswordView';
import UserView from '@/views/UserView';
import UserForm from '@/components/user/UserForm';
import OnlineLayout from '@/layouts/OnlineLayout';
import UserDetailView from '@/views/UserDetailView';
import ActivateAccountView from '@/views/ActivateAccountView';
import OfficeView from '@/views/OfficeView';
import StakeholderView from '@/views/StakeholderView';
import StakeholderForm from '@/components/stakeholder/StakeholderForm';
import LineIdView from '@/views/LineIdView';
import LineIdForm from '@/components/lineId/LineIdForm';
import OfficeForm from '@/components/office/OfficeForm';
import OfficeDetailView from '@/views/OfficeDetailView';
import CreateRequestView from '@/views/CreateRequestView';
import UserAppointmentsView from '@/views/UserAppointmentsView';
import Err403View from '@/views/Err403View';
import Err404View from '@/views/Err404View';
import {ADMIN_ROLE, AGENT_ROLE, CONTACT_ROLE} from '@/shared/constants';
import AppointmentDetailView from '@/views/AppointmentDetailView';
import AppointmentsView from '@/views/AppointmentsView';
import CguView from '@/views/CguView';
import LegacyNoticeView from '@/views/LegacyNoticeView';
import BarcodeView from '@/views/BarcodeView';
import LineIdDetailView from '@/views/LineIdDetailView';
import CreateImmediateTaggingView from '@/views/CreateImmediateTaggingView.vue';
import ImmediateTaggingDetailView from '@/views/ImmediateTaggingDetailView.vue';
import UserTagHistoryView from '@/views/UserTagHistoryView';
import SpecialRequestView from '@/views/SpecialRequestView.vue';
import SpecialRequestCreateView from '@/views/SpecialRequestCreateView.vue';
import SpecialRequestUpdateView from '@/views/SpecialRequestUpdateView.vue';
import EquipmentTypeView from '@/views/EquipmentTypeView.vue';
import RoamingTeamView from '@/views/RoamingTeamView.vue';
import RoamingTeamForm from '@/components/roamingTeam/RoamingTeamForm.vue';
import EquipmentTypeForm from '@/components/equipmenttype/EquipmentTypeForm.vue';
import RoamingTeamDetail from '@/components/roamingTeam/RoamingTeamDetail.vue';
import SiteView from '@/views/SiteView.vue';
import SiteForm from '@/components/site/SiteForm.vue';
import SiteDetail from '@/components/site/SiteDetail.vue';
import VenueView from '@/views/VenueView.vue';
import VenueForm from '@/components/venue/VenueForm.vue';
import VenueDetailView from '@/views/VenueDetailView.vue';
import MaintenanceView from '@/views/MaintenanceView.vue';
import SettingsView from '@/views/SettingsView.vue';

const routes = [
  {
    path: '/login',
    name: 'login',
    component: LoginView,
    meta: {requiresNotAuth: true},
  },
  {
    path: '/resetPassword',
    name: 'resetPassword',
    component: ResetPasswordView,
    meta: {requiresNotAuth: true},
  },
  {
    path: '/changePassword',
    name: 'changePassword',
    component: ChangePasswordView,
  },
  {
    path: '/activate',
    name: 'activate',
    component: ActivateAccountView,
    meta: {requiresNotAuth: true},
  },
  {
    path: '/legacyNotice',
    name: 'legacyNotice',
    component: LegacyNoticeView,
  },
  {
    path: '/cgu',
    name: 'cgu',
    component: CguView,
  },
  {
    path: '/403',
    name: '403',
    component: Err403View,
  },
  {
    path: '/404',
    name: '404',
    component: Err404View,
  },
  {
    path: '/503',
    name: '503',
    component: MaintenanceView,
  },
  {
    path: '/:pathMatch(.*)*',
    name: '404',
    component: Err404View,
  },
  {
    path: '/',
    name: 'online',
    component: OnlineLayout,
    meta: {requiresAuth: true},
    children: [
      {
        path: '',
        name: 'home',
        component: HomeView,
        meta: {requiresAuth: true},
      },
      {
        path: 'appointment',
        name: 'appointment',
        component: AppointmentsView,
        meta: {requiresAuth: true, requiresRole: [ADMIN_ROLE, AGENT_ROLE]},
      },
      {
        path: 'appointment/:id',
        name: 'appointmentDetail',
        component: AppointmentDetailView,
        meta: {requiresAuth: true},
      },
      {
        path: 'appointment/new/:userId?',
        name: 'appointmentCreate',
        component: CreateRequestView,
        meta: {requiresAuth: true},
      },
      {
        path: 'appointment/user/:userId?',
        name: 'userAppointment',
        component: UserAppointmentsView,
        meta: {requiresAuth: true},
      },
      {
        path: 'immediate-tagging',
        name: 'immediateTagging',
        component: CreateImmediateTaggingView,
        meta: {requiresAuth: true, requiresRole: [ADMIN_ROLE, AGENT_ROLE]},
      },
      {
        path: 'immediate-tagging/:id',
        name: 'immediateTaggingDetail',
        component: ImmediateTaggingDetailView,
        meta: {requiresAuth: true},
      },
      {
        path: 'tag-history',
        name: 'tagHistory',
        component: UserTagHistoryView,
        meta: {requiresAuth: true, requiresRole: [CONTACT_ROLE]},
      },
      {
        path: 'user',
        name: 'user',
        component: UserView,
        meta: {requiresAuth: true},
      },
      {
        path: 'user/new',
        name: 'userCreate',
        component: UserForm,
        meta: {requiresAuth: true, requiresRole: [ADMIN_ROLE]},
      },
      {
        path: 'user/:id/edit',
        name: 'userUpdate',
        component: UserForm,
        meta: {requiresAuth: true, requiresRole: [ADMIN_ROLE, AGENT_ROLE]},
      },
      {
        path: 'user/:id',
        name: 'userDetail',
        component: UserDetailView,
        meta: {requiresAuth: true},
      },
      {
        path: 'tag',
        name: 'tag',
        component: BarcodeView,
        meta: {requiresAuth: true, requiresRole: [ADMIN_ROLE, AGENT_ROLE]},
      },
      {
        path: 'office',
        name: 'office',
        component: OfficeView,
        meta: {requiresAuth: true, requiresRole: [ADMIN_ROLE]},
      },
      {
        path: 'office/new',
        name: 'officeCreate',
        component: OfficeForm,
        meta: {requiresAuth: true, requiresRole: [ADMIN_ROLE]},
      },
      {
        path: 'office/:id/edit',
        name: 'officeUpdate',
        component: OfficeForm,
        meta: {requiresAuth: true, requiresRole: [ADMIN_ROLE]},
      },
      {
        path: 'office/:id',
        name: 'officeDetail',
        component: OfficeDetailView,
        meta: {requiresAuth: true, requiresRole: [ADMIN_ROLE]},
      },
      {
        path: 'stakeholder',
        name: 'stakeholder',
        component: StakeholderView,
        meta: {requiresAuth: true, requiresRole: [ADMIN_ROLE]},
      },
      {
        path: 'stakeholderAdd',
        name: 'stakeholderAdd',
        component: StakeholderForm,
        meta: {requiresAuth: true, requiresRole: [ADMIN_ROLE]},
      },
      {
        path: 'stakeholder/:id/edit',
        name: 'stakeholderUpdate',
        component: StakeholderForm,
        meta: {requiresAuth: true, requiresRole: [ADMIN_ROLE]},
      },
      {
        path: 'lineId',
        name: 'lineId',
        component: LineIdView,
        meta: {requiresAuth: true, requiresRole: [ADMIN_ROLE, AGENT_ROLE]},
      },
      {
        path: 'lineId/new',
        name: 'lineIdCreate',
        component: LineIdForm,
        meta: {requiresAuth: true, requiresRole: [ADMIN_ROLE]},
      },
      {
        path: 'lineId/:id/edit',
        name: 'lineIdUpdate',
        component: LineIdForm,
        meta: {requiresAuth: true, requiresRole: [ADMIN_ROLE]},
      },
      {
        path: 'lineId/:id',
        name: 'lineIdDetail',
        component: LineIdDetailView,
        meta: {requiresAuth: true},
      },
      {
        path: 'specialRequest',
        name: 'specialRequest',
        component: SpecialRequestView,
        meta: {requiresAuth: true, requiresRole: [ADMIN_ROLE]},
      },
      {
        path: 'specialRequest/new/',
        name: 'createSpecialRequest',
        component: SpecialRequestCreateView,
        meta: {requiresAuth: true, requiresRole: [CONTACT_ROLE]},
      },
      {
        path: 'specialRequest/:id/edit',
        name: 'specialRequestUpdateView',
        component: SpecialRequestUpdateView,
        meta: {requiresAuth: true, requiresRole: [ADMIN_ROLE]},
      },
      {
        path: 'equipmentType',
        name: 'equipmentType',
        component: EquipmentTypeView,
        meta: {requiresAuth: true, requiresRole: [ADMIN_ROLE]},
      },
      {
        path: 'roamingTeam',
        name: 'roamingTeam',
        component: RoamingTeamView,
        meta: {requiresAuth: true, requiresRole: [ADMIN_ROLE]},
      },
      {
        path: 'roamingTeam/new',
        name: 'roamingTeamCreate',
        component: RoamingTeamForm,
        meta: {requiresAuth: true, requiresRole: [ADMIN_ROLE]},
      },
      {
        path: 'roamingTeam/:id',
        name: 'roamingTeamDetail',
        component: RoamingTeamDetail,
        meta: {requiresAuth: true, requiresRole: [ADMIN_ROLE]},
      },
      {
        path: 'roamingTeam/:id/edit',
        name: 'roamingTeamUpdate',
        component: RoamingTeamForm,
        meta: {requiresAuth: true, requiresRole: [ADMIN_ROLE]},
      },
      {
        path: 'equipmentType/new',
        name: 'equipmentTypeCreate',
        component: EquipmentTypeForm,
        meta: {requiresAuth: true, requiresRole: [ADMIN_ROLE]},
      },
      {
        path: 'equipmentType/:id/edit',
        name: 'equipmentTypeUpdate',
        component: EquipmentTypeForm,
        meta: {requiresAuth: true, requiresRole: [ADMIN_ROLE]},
      },
      {
        path: 'site',
        name: 'site',
        component: SiteView,
        meta: {requiresAuth: true, requiresRole: [ADMIN_ROLE]},
      },
      {
        path: 'site/new',
        name: 'siteCreate',
        component: SiteForm,
        meta: {requiresAuth: true, requiresRole: [ADMIN_ROLE]},
      },
      {
        path: 'site/:id',
        name: 'siteDetail',
        component: SiteDetail,
        meta: {requiresAuth: true, requiresRole: [ADMIN_ROLE]},
      },
      {
        path: 'site/:id/edit',
        name: 'siteUpdate',
        component: SiteForm,
        meta: {requiresAuth: true, requiresRole: [ADMIN_ROLE]},
      },
      {
        path: 'venue',
        name: 'venue',
        component: VenueView,
        meta: {requiresAuth: true, requiresRole: [ADMIN_ROLE]},
      },
      {
        path: 'venue/new',
        name: 'venueCreate',
        component: VenueForm,
        meta: {requiresAuth: true, requiresRole: [ADMIN_ROLE]},
      },
      {
        path: 'venue/:id/edit',
        name: 'venueUpdate',
        component: VenueForm,
        meta: {requiresAuth: true, requiresRole: [ADMIN_ROLE]},
      },
      {
        path: 'venue/:id',
        name: 'venueDetail',
        component: VenueDetailView,
        meta: {requiresAuth: true, requiresRole: [ADMIN_ROLE]},
      },
      {
        path: 'settings',
        name: 'settings',
        component: SettingsView,
        meta: {requiresAuth: true, requiresRole: [ADMIN_ROLE]},
      }
    ],
  },
];

const router = createRouter({
  linkExactActiveClass: 'active',
  history: createWebHashHistory(),
  routes,
});

export default router;
